// extracted by mini-css-extract-plugin
module.exports = {"home":"navigate_home__DZSKL","title":"navigate_title___N1_A","opt":"navigate_opt__1STzq"};